export default __webpack_public_path__ + "static/media/icons.a01e3f2d.eot";